var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVehicle = function SvgVehicle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0826 3.46066C9.8519 3.00932 9.37997 2.72412 8.86399 2.72412H1.44236C0.940456 2.72412 0.533936 3.12171 0.533936 3.61259V8.49917C0.533936 8.74438 0.737423 8.9434 0.988148 8.9434H1.53027C1.53027 8.2073 2.14028 7.6107 2.89291 7.6107C3.64554 7.6107 4.25555 8.2073 4.25555 8.9434H6.98082C6.98082 8.2073 7.59083 7.6107 8.34346 7.6107C9.09609 7.6107 9.7061 8.2073 9.7061 8.9434H11.0687C11.3195 8.9434 11.5229 8.74438 11.5229 8.49917V6.27799L10.0826 3.46066Z",
    fill: "#2E3744",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89291 10.276C3.64548 10.276 4.25555 9.67933 4.25555 8.9433C4.25555 8.20727 3.64548 7.6106 2.89291 7.6106C2.14035 7.6106 1.53027 8.20727 1.53027 8.9433C1.53027 9.67933 2.14035 10.276 2.89291 10.276Z",
    fill: "#FAFAFA",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34347 10.276C9.09604 10.276 9.70611 9.67933 9.70611 8.9433C9.70611 8.20727 9.09604 7.6106 8.34347 7.6106C7.59091 7.6106 6.98083 8.20727 6.98083 8.9433C6.98083 9.67933 7.59091 10.276 8.34347 10.276Z",
    fill: "#FAFAFA",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.841675 4.04321C0.841675 3.49093 1.28939 3.04321 1.84167 3.04321H7.04319V5.51714H0.841675V4.04321Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64941 3.03809C7.64941 3.03809 7.86717 3.03809 8.71377 3.03809C9.56036 3.03809 9.72703 3.43614 9.98008 3.93115C10.376 4.70554 10.5827 5.10988 10.7872 5.51723C9.98612 5.51723 7.64941 5.51723 7.64941 5.51723V3.03809Z",
    fill: "#FAFAFA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVehicle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vehicle.144ec1e4354ad57a7bcf5cbafbed4e23.svg";